import './src/styles/reset.scss';
import './src/styles/global.scss';
import './src/styles/typography.scss';

require('typeface-roboto');
require('typeface-roboto-condensed');
require('typeface-playfair-display');